import type { IChatPoll } from "@/types/(my-space)/chat.interface";

export interface PollVoteGroup {
  id: number;
  text: string;
  voteCount: number;
  /** Who voted for it: me first (if I did), then in the server's order. */
  voterIds: number[];
}

/** The poll's options, in order, each with its voters — me first. */
export const pollVoteGroups = (poll: IChatPoll, myUserId: number | undefined): PollVoteGroup[] =>
  poll.options.map((o) => {
    const unique = [...new Set(o.voterIds)];
    const voterIds =
      myUserId != null && unique.includes(myUserId)
        ? [myUserId, ...unique.filter((id) => id !== myUserId)]
        : unique;
    return { id: o.id, text: o.text, voteCount: o.voteCount, voterIds };
  });
